document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var dur = 1400;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var prog = Math.min((ts - inicio) / dur, 1);
          var valor = fin * prog;
          el.textContent = (fin % 1 === 0) ? Math.round(valor) : valor.toFixed(1);
          if (prog < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
        obs.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-mt-src');
        var srcset = mini.getAttribute('data-mt-srcset');
        if (src) principal.src = src;
        if (srcset) principal.srcset = srcset;
        minis.forEach(function (m) { m.classList.remove('mt-activa'); });
        mini.classList.add('mt-activa');
      });
    });
  });
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var contenedorProducto = form.closest('.mt-producto__wrap') || form;
    var pillGrupos = form.querySelectorAll('[data-mt-opcion-grupo]');
    var idInput = form.querySelector('[data-mt-variant-id]');
    var precioActual = contenedorProducto.querySelector('[data-mt-precio-actual]');
    var precioAntes = contenedorProducto.querySelector('[data-mt-precio-antes]');
    var ahorroEl = contenedorProducto.querySelector('[data-mt-ahorro]');
    var botonSubmit = form.querySelector('[data-mt-submit]');
    var notaStock = form.querySelector('[data-mt-nota-stock]');
    var imagenPrincipal = contenedorProducto.querySelector('[data-mt-imagen-principal]');
    var miniaturas = contenedorProducto.querySelectorAll('[data-mt-miniatura]');

    function opcionesSeleccionadas() {
      var seleccion = [];
      pillGrupos.forEach(function (grupo) {
        var activa = grupo.querySelector('.mt-activa');
        seleccion.push(activa ? activa.getAttribute('data-mt-valor') : null);
      });
      return seleccion;
    }

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      });
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var variante = variantes.find(function (v) {
        return v.options.every(function (op, i) { return seleccion[i] == null || op === seleccion[i]; });
      });
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioActual) precioActual.textContent = formatearDinero(variante.price);
      if (precioAntes) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntes.textContent = formatearDinero(variante.compare_at_price);
          precioAntes.style.display = '';
          if (ahorroEl) {
            var pct = Math.round((1 - variante.price / variante.compare_at_price) * 100);
            ahorroEl.textContent = '-' + pct + '%';
            ahorroEl.style.display = '';
          }
        } else {
          precioAntes.style.display = 'none';
          if (ahorroEl) ahorroEl.style.display = 'none';
        }
      }
      if (botonSubmit) {
        botonSubmit.disabled = !variante.available;
        botonSubmit.textContent = variante.available
          ? botonSubmit.getAttribute('data-mt-texto-disponible')
          : botonSubmit.getAttribute('data-mt-texto-agotado');
      }
      if (notaStock) {
        notaStock.style.display = variante.available ? 'none' : '';
      }
      if (variante.image && imagenPrincipal) {
        imagenPrincipal.src = variante.image;
        var rutaVariante = variante.image.split('?')[0];
        miniaturas.forEach(function (m) {
          var rutaMiniatura = (m.getAttribute('data-mt-src') || '').split('?')[0];
          m.classList.toggle('mt-activa', rutaMiniatura !== '' && rutaMiniatura === rutaVariante);
        });
      }
    }

    pillGrupos.forEach(function (grupo) {
      grupo.querySelectorAll('[data-mt-valor]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.hasAttribute('disabled')) return;
          grupo.querySelectorAll('[data-mt-valor]').forEach(function (p) { p.classList.remove('mt-activa'); });
          pill.classList.add('mt-activa');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initCantidadProducto() {
  document.querySelectorAll('[data-mt-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-mt-menos]');
    var mas = wrap.querySelector('[data-mt-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}
